import React from 'react'
import './template_msg.css'
import './msg_manage.css'
import MsgPreview from "./msg_preview";
import Util from "../../public/utils";
import MsgUtil from "../../ext/msg/msg_util";
import ColPicker from "../../colpicker";
import TaskposterUtil from "../../ext/taskpost/taskposter_util";
import Vars from "../../cmpts/system_vars";
import DashedAddButton from "../../cmpts/button/DashedAddButton";
import {ExclamationCircleOutlined, EyeOutlined} from '@ant-design/icons';
import {Button, Col, Dropdown, Input, Menu, Modal, Row, Select} from 'antd';
import MsgTemplateSelector from "../../cmpts/selector/MsgTemplateSelector";
import Message from "../../cmpts/ant/Message";
import MxdModal from "../../cmpts/modal";
import {URL_TP_TEMPLATE_CHECK} from "../../public/variables";
import {FetchUtil} from "../../public/fetch_util";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";

const {Option} = Select;

/**
 * @param id 必填且唯一，区别不用模板消息
 * @param onChange 用户创建完成模板消息后，模板消息内容回调
 * @param msg 模板消息的内容，可用于复显
 * @param subs 公众号信息
 */
class ZkAddTemplateMsg extends React.Component {

    constructor(props) {
        super(props);
        this.setCreateMsgModalVisible = this.setCreateMsgModalVisible.bind(this);
        this.showEditTemplateMsg = this.showEditTemplateMsg.bind(this);
        this.templateChange = this.templateChange.bind(this);
        this.parseMsg = this.parseMsg.bind(this);
        this.colpick = this.colpick.bind(this);
        this.setMsgData = this.setMsgData.bind(this);
        this.linkChange = this.linkChange.bind(this);
        this.insertNickName = this.insertNickName.bind(this);
        this.insertCompletedTaskNum = this.insertCompletedTaskNum.bind(this);
        this.insertUncompletedTaskNum = this.insertUncompletedTaskNum.bind(this);
        this.insertStockSurplus = this.insertStockSurplus.bind(this);
        this.insertTime = this.insertTime.bind(this);
        this.showPreview = this.showPreview.bind(this);
        this.mouseOverPhoneScroll = this.mouseOverPhoneScroll.bind(this);
        this.mouseLeavePhoneScroll = this.mouseLeavePhoneScroll.bind(this);
        this.showInsertTools = this.showInsertTools.bind(this);
        this.hideInsertTools = this.hideInsertTools.bind(this);
        this.save = this.save.bind(this);
        this.editOnClick = this.editOnClick.bind(this);
        this.recovery = this.recovery.bind(this);
        this.insertRedeemcode = this.insertRedeemcode.bind(this);
        this.insertRedeemcode2 = this.insertRedeemcode2.bind(this);
        this.insertRedeemcode3 = this.insertRedeemcode3.bind(this);
        this.subsChange = this.subsChange.bind(this);
        this.cancel = this.cancel.bind(this);
        this.initSubs = this.initSubs.bind(this);
        this.init = this.init.bind(this);
        this.templateCheck = this.templateCheck.bind(this);
        this.checkSuccess = this.checkSuccess.bind(this);
        this.showNoTemplateSubs = this.showNoTemplateSubs.bind(this);
        this.getStockSurplusMenu = this.getStockSurplusMenu.bind(this);
        let varsStatus = {};
        if (props.vars) {
            for (var i = 0; i < props.vars.length; i++) {
                varsStatus[props.vars[i]] = true;
            }
        }
        this.state = {
            varsStatus: varsStatus,
            keynote_list: [],
            msg: null,
            linkType: {
                value: 0,
                text: '不跳转'
            },
            bindForm: props.bindForm,
            createMsgModalVisible: false,
            step: 1,
            subs: [],
            currentSubsIndex: 0,
            selectTemplate: null,
            msgTitle: '',
            templateId: '',
            noTemplateSubsTip: ''
        };
    }

    componentDidMount() {
        // this.msgScroll = Util.initScroll(this.refs.msgScroll);
        // this.phoneScroll2 = Util.initScroll(this.refs.phoneScroll2);
        this.init(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.init(nextProps);
    }

    init(props) {
        this.initSubs(props.subs);
        if (props.msg) {
            let msg = props.msg;
            this.recovery(msg);
        } else if (Util.isNull(this.state.msg) && props.oldMsg) {
            this.recovery(props.oldMsg, true)
        } else {
            this.setState({
                currentMsg: null,
                step: 1
            })
        }
        let varsStatus = {};
        if (props.vars) {
            for (var i = 0; i < props.vars.length; i++) {
                varsStatus[props.vars[i]] = true;
            }
        }
        this.setState({
            bindForm: props.bindForm,
            varsStatus: varsStatus,
        });
    }

    getStockSurplusMenu(key, i) {
        return <Menu>
            <Menu.Item key="0">
                <a onClick={this.insertStockSurplus.bind(this, key, i)}>
                    插入一阶任务库存剩余
                </a>
            </Menu.Item>
            <Menu.Item key="1">
                <a onClick={this.insertStockSurplus2.bind(this, key, i)}>
                    插入二阶任务库存剩余
                </a>
            </Menu.Item>
            <Menu.Item key="2">
                <a onClick={this.insertStockSurplus3.bind(this, key, i)}>
                    插入三阶任务库存剩余
                </a>
            </Menu.Item>
        </Menu>
    }

    initSubs(subs) {
        if (subs) {
            let list = [];
            list.push(subs);
            if (list.length > 0) {
                this.setState({
                    currentSubsIndex: 0,
                    subs: list
                })
            }
        }
    }

    recovery(tmsg, old) {
        if (typeof tmsg == 'string') {
            tmsg = JSON.parse(tmsg);
        }
        let msg = tmsg.msg;
        let appId = msg.appId;
        let subs = this.state.subs;
        for (let i = 0; i < subs.length; i++) {
            if (subs[i].appId == appId) {
                this.setState({
                    currentSubsIndex: i,
                    templateId: msg.templateId
                });
            }
        }
        let id = this.props.id;
        let keynote_list = MsgUtil.getKeynoteList(msg.content);
        for (var i = 0; i < keynote_list.length; i++) {
            if (keynote_list[i].key != 'url' && keynote_list[i].key != 'miniprogram') {
                keynote_list[i]['color'] = msg.data[keynote_list[i].key] ? msg.data[keynote_list[i].key].color : '#00000';
            }
            keynote_list[i]['rdn'] = Math.round(Math.random() * 10000);
        }
        var linkType = {
            value: 0,
            text: '不跳转'
        };
        if (msg.link.type == 1) {
            linkType = {
                value: 1,
                text: '跳转到链接'
            }
            $("#url" + id).val(msg.link.url);
        }
        if (msg.link.type == 2) {
            linkType = {
                value: 2,
                text: '跳转到小程序'
            }
            $("#mappid" + id).val(msg.link.miniprogram.appid);
            $("#mpage" + id).val(msg.link.miniprogram.pagepath);
        }
        if (msg.link.type == 3) {
            linkType = {
                value: 3,
                text: '跳转到排行榜'
            }
        }
        if (msg.link.type == 4) {
            linkType = {
                value: 4,
                text: '跳转到关联表单'
            }
        }
        if (old) {
            let subsList = [];
            for (let i = 0; i < subs.length; i++) {
                subsList.push(subs[i].appId);
            }
            tmsg['subsList'] = subsList;
        }
        this.setState({
            keynote_list: keynote_list,
            msg: JSON.parse(JSON.stringify(msg)),
            currentMsg: old ? null : JSON.parse(JSON.stringify(tmsg)),
            oldMsg: old ? tmsg : null,
            linkType: linkType,
            template: {
                title: msg.title
            }
        });
        let setMsgData = this.setMsgData;
        setTimeout(function () {
            $('#newTemplateMsg' + id + ' .insert-icon').tooltip();
            $("#newTemplateMsg" + id + " .rich-text-editor-content").on("input", function (e) {
                var value = TaskposterUtil.transformOutMsg(e.target);
                var key = e.target.getAttribute('data-key');
                setMsgData(key, value);
            });
        }, 200);
        setTimeout(function () {
            for (var i = 0; i < keynote_list.length; i++) {
                if (keynote_list[i].key != 'url' && keynote_list[i].key != 'miniprogram') {
                    if (document.querySelector("#editor" + id + i)) {
                        TaskposterUtil.transformInMsg("editor" + id + i, msg.data[keynote_list[i].key] ? msg.data[keynote_list[i].key].value : '');
                    }
                }
            }
            if (msg.link.type == 1) {
                $("#url" + id).val(msg.link.url);
            }
            if (msg.link.type == 2) {
                $("#mappid" + id).val(msg.link.miniprogram.appid);
                $("#mpage" + id).val(msg.link.miniprogram.pagepath);
            }
        }, 200)
    }

    mouseOverPhoneScroll() {
        // this.msgScroll.disable();
    }

    mouseLeavePhoneScroll() {
        // this.msgScroll.enable();
    }

    setCreateMsgModalVisible(flag) {
        this.setState({
            createMsgModalVisible: flag
        });
        if (flag) {
            if (Util.isNull(this.state.currentMsg) && !Util.isNull(this.state.oldMsg)) {
                let msg = this.state.oldMsg
                this.recovery(msg, true);
                this.setState({
                    step: 2,
                    msgTitle: msg.msg.title,
                });
            }
            Util.disableScroll();
        } else {
            Util.enableScroll();
        }
    }

    showEditTemplateMsg() {
        let msg = this.state.currentMsg;
        if (msg) {
            this.recovery(msg);
        }
        this.setState({
            step: 2,
            msgTitle: msg.msg.title,
        });
        this.setCreateMsgModalVisible(true);
    }

    templateChange(template) {
        this.setState({
            selectTemplate: template,
            msgTitle: template.title,
            templateId: template.template_id,
        });
    }

    parseMsg(template) {
        var keynote_list = MsgUtil.getKeynoteList(template.content);
        var data = {};
        for (var i = 0; i < keynote_list.length; i++) {
            if (keynote_list[i].key == 'url' || keynote_list[i].key == 'miniprogram') {
                continue;
            }
            data[keynote_list[i].key] = {
                value: ''
            }
        }
        this.setState({
            keynote_list: keynote_list,
            msg: {
                url: '',
                title: template.title,
                data: data,
                content: template.content,
                templateId: template.template_id,
                miniprogram: {
                    "appid": "",
                    "pagepath": ""
                }
            },
            linkType: {
                value: 0,
                text: '不跳转'
            }
        });
        $('#newTemplateMsg' + this.props.id + ' .msgInput').val('');
        $("#mappid" + this.props.id).val('');
        $("#mpage" + this.props.id).val('');
        $('#newTemplateMsg' + this.props.id + " .editorContent").html('');
        $('#newTemplateMsg' + this.props.id + ' .color-box').css({
            'background-color': '#000000'
        });
        var setMsgData = this.setMsgData;
        var id = this.props.id;
        setTimeout(function () {
            $('#newTemplateMsg' + id + ' .insert-icon').tooltip();
            $("#newTemplateMsg" + id + " .rich-text-editor-content").on("input", function (e) {
                var value = TaskposterUtil.transformOutMsg(e.target);
                var key = e.target.getAttribute('data-key');
                setMsgData(key, value);
            });
        }, 200);
    }

    setMsgData(key, value) {
        if (key == 'first' || key == 'remark') {
            if (value.endsWith('\n')) {
                value = value.substring(0, value.length - 1);
            }
        } else {
            // var re = new RegExp("\n", "g");
            // value = value.replace(re, '');
        }
        var msg = this.state.msg;
        msg.data[key].value = value;
        this.setState({
            msg: msg
        })
    }

    colpick(id, color) {
        var index = id.replace('colpick' + this.props.id, '');
        var msg = this.state.msg;
        var key = this.state.keynote_list[index].key;
        msg.data[key].color = color;
        this.setState({
            msg: msg
        });
    }

    showInsertTools(e) {
        var target = $(e.currentTarget);
        var tools = target.siblings('.rich-text-editor-tools');
        tools.removeClass('hide');
        target.addClass('editWithTools');
    }

    editOnClick(e) {
        TaskposterUtil.textAreaClick(e);
        // this.msgScroll.disable();
    }

    hideInsertTools(e) {
        var target = $(e.currentTarget);
        var tools = target.siblings('.rich-text-editor-tools');
        tools.addClass('hide');
        target.removeClass('editWithTools');
        // this.msgScroll.enable();
    }

    selectLinkType(val) {
        let data = {};
        if (val == 0) {
            data = {
                value: 0,
                text: '不跳转'
            };
        } else if (val == 1) {
            data = {
                value: 1,
                text: '跳转到链接'
            };
        } else if (val == 2) {
            data = {
                value: 2,
                text: '跳转到小程序'
            }
        }
        if (this.state.linkType.value != val) {
            let msg = this.state.msg;
            msg.url = '';
            msg.miniprogram = {};
            this.setState({
                msg: msg
            })
        }
        this.setState({
            linkType: data
        });
    }

    linkChange(e) {
        var target = e.target;
        var key = target.getAttribute('data-key');
        var value = target.value;
        var msg = this.state.msg;
        if (key == 'url') {
            // if (value && value.indexOf("http://") < 0 && value.indexOf('https://') < 0) {
            //     msg.url = 'http://' + value;
            // } else {
            //     msg.url = value;
            // }
            msg.url = value;
        } else if (key == 'miniprogram') {
            var id = target.getAttribute('id');
            if (id == ('mappid' + this.props.id)) {
                msg.miniprogram['appid'] = value;
            } else {
                msg.miniprogram['pagepath'] = value;
            }
        }
        this.setState({
            msg: msg
        })
    }

    insertNickName(e) {
        e.stopPropagation();
        TaskposterUtil.insertNickName(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertCompletedTaskNum(e) {
        TaskposterUtil.insertCompletedTaskNum(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertUncompletedTaskNum(e) {
        TaskposterUtil.insertUncompletedTaskNum(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertStockSurplus(key, index, e) {
        TaskposterUtil.insertStockSurplus(e);
        let value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertStockSurplus2(key, index, e) {
        TaskposterUtil.insertStockSurplus2(e);
        let value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertStockSurplus3(key, index, e) {
        TaskposterUtil.insertStockSurplus3(e);
        let value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertTime(e) {
        TaskposterUtil.insertTime(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertRedeemcode(e) {
        TaskposterUtil.insertRedeemcode(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertRedeemcode2(e) {
        TaskposterUtil.insertRedeemcode2(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertRedeemcode3(e) {
        TaskposterUtil.insertRedeemcode3(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertHtmlCom(type, e) {
        TaskposterUtil.insertFormCom(type, e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    showPreview() {
        MxdModal.show("#msgPreview" + this.props.id);
    }

    save() {
        if (this.state.step == 1) {
            //选择模板
            if (this.state.selectTemplate && this.state.selectTemplate.appId === this.state.subs[this.state.currentSubsIndex].appId) {
                this.setState({
                    step: 2
                });
                this.parseMsg(this.state.selectTemplate);
            } else {
                Message.warning("请选择消息模板");
                return;
            }
        } else {
            //保存
            var linkType = this.state.linkType;
            var link = {
                type: 0
            };
            if (linkType.value == 1) {
                //链接
                var url = $("#url" + this.props.id).val();
                if (url.length == 0) {
                    Message.warning("请输入链接地址");
                    $("#url" + this.props.id).focus();
                    return
                }
                link = {
                    type: linkType.value,
                    url: url
                }
            } else if (linkType.value == 2) {
                //小程序
                var appid = $("#mappid" + this.props.id).val();
                var pagepath = $("#mpage" + this.props.id).val();
                if (appid.length == 0) {
                    Message.warning("请输入小程序appid");
                    $("#mappid" + this.props.id).focus();
                    return;
                }
                if (pagepath.length == 0) {
                    Message.warning("请输入小程序跳转路径");
                    $("#mpage" + this.props.id).focus();
                    return;
                }
                link = {
                    type: linkType.value,
                    miniprogram: {
                        appid: appid,
                        pagepath: pagepath
                    }
                }
            } else if (linkType.value >= 3) {
                link = {
                    type: linkType.value
                }
            }
            var msg = this.state.msg;
            var str = JSON.stringify(msg);
            var tmp = JSON.parse(str);
            tmp.link = link;
            tmp.appId = this.state.subs[this.state.currentSubsIndex].appId;
            let currentMsg = this.state.currentMsg;
            // console.log(currentMsg)
            // if (currentMsg) {
            //     currentMsg.msg = tmp;
            // } else {
            let subsList = [];
            let subs = this.state.subs;
            for (let i = 0; i < subs.length; i++) {
                subsList.push({
                    appId: subs[i].appId,
                    templateId: this.state.currentSubsIndex == i ? this.state.templateId : null
                })
            }
            currentMsg = {
                msg: tmp,
                // subsList: subsList
            };
            // }
            this.checkSuccess(currentMsg);
            // this.templateCheck(currentMsg);
        }
    }

    templateCheck(currentMsg) {
        let subsList = currentMsg.subsList;
        if (subsList && subsList.length > 0) {
            let fetchUtil = new FetchUtil();
            fetchUtil.init()
                .setUrl(URL_TP_TEMPLATE_CHECK)
                .setMethod('POST')
                .setCookieCors()
                .setBodyType('json')
                .setBody({
                    msg: {
                        content: currentMsg.msg.content
                    },
                    subsList: currentMsg.subsList
                })
                .dofetch()
                .then((msg) => {
                    if (msg.respCode == 0) {
                        let subsList = msg.respMsg.subsList;
                        let notempleteSubs = [];
                        for (let i = 0; i < subsList.length; i++) {
                            if (Util.isNull(subsList[i].templateId)) {
                                notempleteSubs.push(subsList[i].appId);
                            }
                        }
                        if (notempleteSubs.length > 0) {
                            this.showNoTemplateSubs(notempleteSubs)
                        } else {
                            currentMsg.subsList = subsList;
                            this.checkSuccess(currentMsg);
                        }
                    } else {
                        Message.warning("系统错误，请稍后再试")
                    }
                })
                .catch((err) => {
                    Message.warning("系统错误，请稍后再试")
                })
        } else {
            this.checkSuccess(currentMsg)
        }
    }

    showNoTemplateSubs(notempleteSubs) {
        let tip = '公众号';
        for (let i = 0; i < notempleteSubs.length; i++) {
            for (let m = 0; m < this.state.subs.length; m++) {
                if (this.state.subs[m].appId == notempleteSubs[i]) {
                    tip += this.state.subs[m].nickName + '、';
                }
            }
        }
        tip = tip.substring(0, tip.length - 1);
        tip += '没有该消息模板';
        this.setState({
            noTemplateSubsTip: tip
        })
    }

    checkSuccess(currentMsg) {
        this.setState({
            currentMsg: currentMsg,
            noTemplateSubsTip: ''
        });
        if (this.props.onChange) {
            this.props.onChange(currentMsg);

        }
        this.setCreateMsgModalVisible(false);
    }

    noEnter(e) {
        if (e.charCode === 13) {
            e.preventDefault();
        }
    }

    subsChange(index) {
        this.setState({
            currentSubsIndex: index
        })
    }

    cancel() {
        if (this.state.step == 1) {
            this.setCreateMsgModalVisible(false);
        } else {
            this.setState({
                step: 1
            })
        }
    }

    preventHideTools(e) {
        e.preventDefault();
    }

    render() {
        var colpick = this.colpick;
        var showInsertTools = this.showInsertTools;
        var hideInsertTools = this.hideInsertTools;
        var selectLinkType = this.selectLinkType;
        var varsStatus = this.state.varsStatus;
        var linkChange = this.linkChange;
        var insertNickName = this.insertNickName;
        var insertCompletedTaskNum = this.insertCompletedTaskNum;
        var insertUncompletedTaskNum = this.insertUncompletedTaskNum;
        var insertStockSurplus = this.insertStockSurplus;
        var insertStockSurplus2 = this.insertStockSurplus2;
        var insertStockSurplus3 = this.insertStockSurplus3;
        let getStockSurplusMenu = this.getStockSurplusMenu;
        var insertRedeemcode = this.insertRedeemcode;
        var insertRedeemcode2 = this.insertRedeemcode2;
        var insertRedeemcode3 = this.insertRedeemcode3;
        var insertTime = this.insertTime;
        let insertHtmlCom = this.insertHtmlCom.bind(this);
        var noEnter = this.noEnter;
        var editOnClick = this.editOnClick;
        var mouseLeavePhoneScroll = this.mouseLeavePhoneScroll;
        var id = this.props.id;
        let preventHideTools = this.preventHideTools;
        return (
            <div>
                {
                    this.state.currentMsg ? <div className={'mangeMsgCard msgCard'}>
                        <div className='mxd-cursor-pointer' onClick={this.showEditTemplateMsg}>
                            <MsgPreview key="1" msg={this.state.currentMsg ? this.state.currentMsg.msg : null}
                                        lite="true"/>
                        </div>
                        <div className='msgOpt'>
                            <EyeOutlined onClick={this.showPreview}/>
                            <EditOutlined onClick={this.showEditTemplateMsg}/>
                        </div>
                        {/*<div className={'msgMask'}>*/}
                        {/*    <div className={'msgMaskIcon'}>*/}
                        {/*        <EyeOutlined onClick={this.showPreview}/>*/}
                        {/*        <EditOutlined   onClick={this.showEditTemplateMsg}/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div> : <DashedAddButton addText={'添加模板消息'} width="220px" height="220px"
                                              onClick={this.setCreateMsgModalVisible.bind(this, true)}/>
                }

                <Modal className="modal-noboder"
                       title={this.state.step == 1 ? "选择模板" : '新建消息'}
                       centered
                       width={this.state.step == 1 ? "580px" : '844px'}
                       visible={this.state.createMsgModalVisible}
                       onCancel={() => this.setCreateMsgModalVisible(false)}
                       footer={[
                           <Button onClick={this.cancel.bind(this)}>{this.state.step == 1 ? '取消' : '重新选择模板'}</Button>,
                           <Button type="primary" onClick={this.save.bind(this)}>
                               {this.state.step == 1 ? "下一步" : '确认'}
                           </Button>
                       ]}>
                    <div id={"newTemplateMsg" + this.props.id} className={'templateContent'}>
                        {
                            this.state.step == 1 ? <MsgTemplateSelector
                                    appId={this.state.subs.length > 0 && this.state.subs[this.state.currentSubsIndex] ? this.state.subs[this.state.currentSubsIndex].appId : ''}
                                    onChange={this.templateChange}
                                    defaultValue={this.state.selectTemplate ? this.state.selectTemplate.template_id : null}/> :
                                <div>
                                    <Row gutter={100}>
                                        <Col span={12}>
                                            <div>
                                                {/*<div className={styles.inputContainer}>*/}
                                                {/*<Row gutter={32}>*/}
                                                {/*<Col span={6} align="right">*/}
                                                {/*<label>公众号</label>*/}
                                                {/*</Col>*/}
                                                {/*<Col span={18}>*/}
                                                {/*<SubsWrap subs={this.state.subs[this.state.currentSubsIndex]}/>*/}
                                                {/*</Col>*/}
                                                {/*</Row>*/}
                                                {/*</div>*/}
                                                <div className={'inputContainer'}>
                                                    <Row gutter={32}>
                                                        <Col span={6} align="right">
                                                            <label>消息标题</label>
                                                        </Col>
                                                        <Col span={18}>
                                                        <span
                                                            className={'msgTitle'}>{this.state.msgTitle}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                {
                                                    this.state.keynote_list.map(function (data, i) {
                                                        if (data.key != 'miniprogram' && data.key != 'url') {
                                                            return (
                                                                <Row gutter={32} key={i}>
                                                                    <Col span={6} align="right">
                                                                        <label>{data.word}</label>
                                                                    </Col>
                                                                    <Col span={18}>
                                                                        <div className={'msgColBox'}><ColPicker
                                                                            id={"colpick" + id + i}
                                                                            key={data.rdn}
                                                                            onChange={colpick}
                                                                            color={data.color ? data.color : '#000000'}/>
                                                                        </div>
                                                                        <div className={'inputContainer'}>
                                                                            <div
                                                                                className='editorWrapper'>
                                                                                <div
                                                                                    id={id + '-tools-' + i}
                                                                                    className={"rich-text-editor-tools hide editorTools"}
                                                                                    onMouseDown={preventHideTools}>
                                                                                    {
                                                                                        varsStatus[Vars.NICKNAME()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-nickname"
                                                                                                title="插入客户昵称"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertNickName}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.FROM_NICKNAME()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-from-nickname"
                                                                                                title="插入好友昵称"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'FROM_NICKNAME')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.COMPLETED_TASK_NUM()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-complete"
                                                                                                title="插入已完成任务量"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertCompletedTaskNum}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.UNCOMPLETED_TASK_NUM()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-uncomplete"
                                                                                                title="插入未完成任务量"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertUncompletedTaskNum}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.STOCKSURPLUS()] ?
                                                                                            <Dropdown
                                                                                                overlay={() => getStockSurplusMenu(data.key, i)}
                                                                                                getPopupContainer={() => document.getElementById(id + '-tools-' + i)}
                                                                                                placement={'topCenter'}>
                                                                                        <span
                                                                                            className="insert-icon icon-stock"></span>
                                                                                            </Dropdown> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.TIME()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-time"
                                                                                                title="插入粉丝收到消息时的当前时间"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertTime}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.REDEEMCODE()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-redeemcode"
                                                                                                title="插入一阶任务兑换码"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertRedeemcode}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.REDEEMCODE2()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-redeemcode"
                                                                                                title="插入二阶任务兑换码"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertRedeemcode2}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.REDEEMCODE3()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-redeemcode"
                                                                                                title="插入三阶任务兑换码"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertRedeemcode3}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GOODS_NAME()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-goods-name"
                                                                                                title="插入商品名称"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GOODS_NAME')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.DATETIME()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-datetime"
                                                                                                title="插入当前时间"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'DATETIME')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GOODS_AMOUNT()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-goods-amount"
                                                                                                title="插入商品价格"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GOODS_AMOUNT')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GROUP_NUM()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-group-num"
                                                                                                title="插入拼团人数"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GROUP_NUM')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GROUP_LIMITEDTIME()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-goods-limiteditime"
                                                                                                title="插入拼团限制时间"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GROUP_LIMITEDTIME')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GROUP_ENDDATE()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-group-enddate"
                                                                                                title="插入拼团截止时间"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GROUP_ENDDATE')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GROUP_BEGINDATE()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-group-begindate"
                                                                                                title="插入拼团开始时间"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GROUP_BEGINDATE')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GROUP_PART_NUM()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-group-part-num"
                                                                                                title="插入已参团人数"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GROUP_PART_NUM')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.GROUP_CREATER()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-group-creater"
                                                                                                title="插入团长昵称"
                                                                                                data-key={data.key}

                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'GROUP_CREATER')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.RETURN_AMOUNT()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-return-amount"
                                                                                                title="插入返现金额"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'RETURN_AMOUNT')}></span> : ''
                                                                                    }
                                                                                    {
                                                                                        varsStatus[Vars.TALLIESDESC()] ?
                                                                                            <span
                                                                                                className="insert-icon icon-talliesdesc"
                                                                                                title="插入奖励金入账说明"
                                                                                                data-key={data.key}
                                                                                                index={i}
                                                                                                onClick={insertHtmlCom.bind(this, 'TALLIESDESC')}></span> : ''
                                                                                    }
                                                                                </div>
                                                                                <div id={"editor" + id + i}
                                                                                     data-key={data.key}
                                                                                     onFocus={showInsertTools}
                                                                                     onBlur={hideInsertTools}
                                                                                     onClick={editOnClick}
                                                                                     className={"rich-text-editor-content text editable editorContent editorContentArea"}
                                                                                     onMouseLeave={mouseLeavePhoneScroll}
                                                                                     contentEditable="true"
                                                                                     placeholder={data.key + ".DATA"}>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                    })
                                                }
                                                {
                                                    this.state.keynote_list.length > 0 && false ?
                                                        <div>
                                                            <Row gutter={32}>
                                                                <Col span={6} align="right">
                                                                    <label>点击消息</label>
                                                                </Col>
                                                                <Col span={18}>
                                                                    <div className={'inputContainer'}>
                                                                        <Select value={this.state.linkType.value}
                                                                                onChange={selectLinkType.bind(this)}
                                                                                style={{width: 120}}>
                                                                            <Option value={0}>不跳转</Option>
                                                                            <Option value={1}>跳转链接</Option>
                                                                            <Option value={2}>跳转小程序</Option>
                                                                        </Select>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <div className={'linkGroup'}>
                                                                {
                                                                    this.state.linkType.value == 1 ?
                                                                        <Row gutter={32}>
                                                                            <Col offset={6}>
                                                                                <div className={'inputContainer'}>
                                                                                    <Input.TextArea
                                                                                        id={"url" + this.props.id}
                                                                                        type="text"
                                                                                        rows={2}
                                                                                        style={{width: 250}}
                                                                                        placeholder="http://或https://开头"
                                                                                        data-key="url"
                                                                                        onChange={linkChange}
                                                                                        value={this.state.msg ? this.state.msg.url : ''}/>
                                                                                </div>
                                                                            </Col>
                                                                        </Row> : ''
                                                                }
                                                                {
                                                                    this.state.linkType.value == 2 ? <div>
                                                                        <Row gutter={32}>
                                                                            <Col offset={6}>
                                                                                <div className='inputContainer'>
                                                                                    <Input id={"mappid" + this.props.id}
                                                                                           type="text"
                                                                                           className="msgInput"
                                                                                           placeholder="小程序appid"
                                                                                           data-key="miniprogram"
                                                                                           onChange={linkChange}
                                                                                           style={{width: 250}}
                                                                                           value={(this.state.msg && this.state.msg.miniprogram) ? this.state.msg.miniprogram.appid : ''}/>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row gutter={32}>
                                                                            <Col offset={6}>
                                                                                <Input id={"mpage" + this.props.id}
                                                                                       type="text"
                                                                                       className="msgInput"
                                                                                       placeholder="小程序跳转地址"
                                                                                       data-key="miniprogram"
                                                                                       onChange={linkChange}
                                                                                       style={{width: 250}}
                                                                                       value={(this.state.msg && this.state.msg.miniprogram) ? this.state.msg.miniprogram.pagepath : ''}/>
                                                                            </Col>
                                                                        </Row>
                                                                    </div> : ''
                                                                }
                                                                {
                                                                    this.state.linkType.value == 3 ?
                                                                        <Row gutter={32}>
                                                                            <Col offset={6}>
                                                                                排行榜链接后台自动绑定，不需要设置
                                                                            </Col>
                                                                        </Row> : ''
                                                                }
                                                            </div>
                                                        </div> : ''
                                                }
                                            </div>
                                            {
                                                this.state.noTemplateSubsTip ? <div>
                                        <span
                                            className="tp-autoclose-des"><ExclamationCircleOutlined/>{this.state.noTemplateSubsTip}
                                        </span>
                                                    &nbsp;&nbsp;&nbsp;<a
                                                    href="https://www.yuque.com/docs/share/33fef840-60ab-457a-9ff5-eb55a48cf006?#"
                                                    target="_blank">如何添加模板？</a>
                                                </div> : ''
                                            }
                                        </Col>
                                        <Col span={12}>
                                            <div className={'phonebg'}>
                                                <div className={'phoneScroll'}>
                                                    <div className={'phoneContent'}>
                                                        {
                                                            this.state.msg ?
                                                                <MsgPreview key="2" msg={this.state.msg}
                                                                            preview="true"/> : ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                        }
                    </div>
                </Modal>
                <div id={"msgPreview" + this.props.id} className={"mxd-modal msgPreviewModal"}>
                    <div className={"mxd-modal-header header"}>
                        <span className='close'></span>
                    </div>
                    <div className="mxd-modal-body">
                        <div className={'phonebg'}>
                            <div className={'phoneScroll'}>
                                <div className={'phoneContent'}>
                                    {
                                        this.state.currentMsg ? <MsgPreview msg={this.state.currentMsg.msg}/> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ZkAddTemplateMsg